import styled from '@emotion/styled';
import React from 'react';
import { Droppable } from 'react-beautiful-dnd-short-press';
import { minBreakpoints, breakpoints, Z_MIDDLE } from 'gatsby-theme-apollo';
import { FaSearch } from 'react-icons/fa';
import { EntityThumbnailSettings } from '../entities/entity-thumbnail';
import EditableText from '../text/editable-text';
import { Flex } from '../layout/flex';
import DevModeIndicator from '../debug/dev-mode-indicator';

const TrayRoot = styled.div(props => ({
  display: `flex`,
  width: `100%`,
  alignItems: `flex-start`,
  [breakpoints.md]: {
    position: `fixed`,
    bottom: `0px`,
    left: `0px`,
  },
  border: `1px solid ${props.theme.divider}`,
  justifyContent: `flex-end`,
  flexDirection: `column`,
  zIndex: Z_MIDDLE,
  backgroundColor: props.theme.backgroundDark
}));

const CharacterTray = styled.div(props => ({
  width: `100%`,
  boxShadow: `0px 0px 2px rgba(0, 0, 0, 0.5)`,
 
  [breakpoints.md]: {
    display: `flex`,
    maxHeight: props.show ? '175px' : '0px',
    overflowY: `hidden`,
    overflowX: `scroll`,
  },
  [minBreakpoints.md]: {
    position: `relative`,
    order: 2
  },
  minHeight: props.show ? `${EntityThumbnailSettings.small.height + 4}px;` : '0px',
  bottom: 0,
  
  transition: `max-height 0.2s ease, min-height .2s ease`,
  padding: `0px`,
  [`::-webkit-scrollbar`]: {
    background: 'black',
    height: `12px`,

  },
  [`::-webkit-scrollbar-thumb`]: {
    background: 'grey',
    borderRadius: '12px'
  }
}));

const ToggleButton = styled.div`
  background-color: ${props => props.theme.backgroundDark};
  padding: 5px 15px;
  font-size: 25px;
  color: ${props => props.theme.text};
  border-left: 1px solid ${props => props.theme.divider};
  border-right: 1px solid ${props => props.theme.divider};
  border-top: 1px solid ${props => props.theme.divider};
  border-top-left-radius: 10px;
  cursor: pointer;
  display: inline-block;
`;

const Controls = styled.div`
  top: -47px;
  right: 0px;
  position: absolute;
  display: inline-block;
`;

const SearchFlex = styled(Flex)(props => ({
  position: 'relative',
  bottom: '0px',
  flexShrink: 0,
  width: '100%',
  padding: '5px 25px',
  [breakpoints.xl]: {
    display: `flex`
  }
}));

const ResultText = styled.h4`
  width: 100%;
  height: 100%;
  text-align: center;
  margin-top: 25px;
  opacity: 0.3;
`;

const Tray = ({
  children,
  show,
  onToggleTray,
  editable,
  onKeyPress,
  logEditorEvent,
  searchText,
  onSearch,
  devMode
}) => {
  return (
    <TrayRoot>
      {editable && (
        <Controls>
          <ToggleButton onClick={() => onToggleTray()}>{show ? '⬇' : '⬆'}</ToggleButton>
        </Controls>
      )}

      <Droppable droppableId="tray" direction="horizontal">
        {provided => (
          <CharacterTray 
            ref={provided.innerRef}
            {...provided.droppableProps} 
            show={show}
          >
            {children}
            {provided.placeholder}
            {children && children.length <= 0 && <ResultText>Empty</ResultText>}
          </CharacterTray>
        )}
      </Droppable>
      {editable && <span style={{fontSize: `12px`, margin: `0 auto`}}>Press and hold to drag and drop! </span> }
      <SearchFlex>
        <Flex
          style={{
            position: 'relative',
            maxWidth: '300px',
            overflowX: 'hidden'
          }}
          flexGrow={0}
        >
          <FaSearch style={{ color: `#333`, position: 'absolute', left: '10px' }} />
          <EditableText
            placeholder="Type to search"
            maxWidth="400px"
            textIndent="25px"
            textValue={searchText}
            onKeyPress={keyCode => {
              if (onKeyPress) {
                onKeyPress(keyCode);
              }
            }}
            dark
            onFocus={text => {
              logEditorEvent('entity_search_start', {
                searchText: text
              });
            }}
            onBlur={text => {
              logEditorEvent('entity_search_complete', {
                searchText: text
              });
            }}
            onInputChanged={newValue => {
              if (onSearch) {
                onSearch(newValue);
              }
            }}
          />
        </Flex>

        {devMode && <DevModeIndicator>Dev Mode!</DevModeIndicator>}
      </SearchFlex>
    </TrayRoot>
  );
};

export default Tray;
